import React from "react";
import { Form, DatePicker, Input, Select } from "antd";
import dayjs from "dayjs";
import { useContext, useEffect } from "react";
import CustomDropdown from "../../../component/CustomDropdown";
import CustomSingleDropdown from "../../../component/CustomeSigleDropDown";
import FilledButton from "../../../component/FilledButton";
import FormInput from "../../../component/FormInput";
import { ContextState } from "../../../layout";
import { ReactComponent as DropArrow } from "../../../assets/images/drop_arrow.svg";
import { rules } from "../../../siteData/rules";
import moment from "moment";
import { useState } from "react";

const status = [{ name: "In progress" }, { name: "Issued" }];

const AddCertificatePop = ({
  handleChangeCert,
  certStatuEdit,
  data,
  course,
  btnLoader,
  userId,
  attachCourse,
  errorData,
  handleError,
  handleAddUser,
  category,
  handleChange,
  formData,
  handleModalClose,
  setFormRef,

  certificate
}) => {
  const [form] = Form.useForm();
  const [status_cert, setStatus_cert] = useState('');

  useEffect(() => {
    setStatus_cert("");
    setFormRef(form);
    onFill();
  }, [certificate]);

  const onFill = () => {
    if (certificate?.length === 1) {
      form.setFieldsValue({
        course: {
          course_id: certificate?.[0]?.course_id,
          label: certificate?.[0]?.name,
          user_id: certificate?.[0]?.user_id,
        },
        certificate_status: ` ${certificate?.[0]?.certificate_status}`,
        issued_date: moment(certificate?.[0]?.course_completed_date),
      });
    }
  };


  return (
    <div>
      <div className="modal_body">
        <div className="add_thought_leader">
          <Form
            form={form}
            name="register"
            onFinish={(e) => certStatuEdit(e, form)}
            onReset={() => { setStatus_cert(""); handleModalClose() }}
            scrollToFirstError
            className="attached_courses-add_skill"
          >
            <h2>CERTIFICATE STATUS</h2>
            <Form.Item
              rules={rules.course}
              label="Certificate course *"
              name="course"
            >
              <Select
                // showSearch
                onFocus={() => handleError({ target: { name: "name" } })}
                name="course"
                labelInValue={true}
                placeholder={"Select from below"}
                suffixIcon={<DropArrow />}
                // initialValues={course[0]?.name}
                type="dropdown"
                className="form_control skill_multiselect"
              >
                {certificate?.map((option) => (
                  <option
                    key={option.course_id}
                    label={option.name}
                    value={option.course_id}
                  >
                    {option.name}
                  </option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              shouldUpdate={(prevValues, curValues) => {
                if (curValues?.course?.value !== prevValues?.course?.value) {
                  let data = form.getFieldValue("course");

                  let value = certificate?.filter(
                    (item) => item?.course_id === data?.value
                  )[0];
                  form.setFieldsValue({
                    course: value,
                    certificate_status: value.certificate_status,
                    issued_date: moment(value?.issued_date),
                  });
                  return true;
                }
                return false;
              }}
            >
              {({ getFieldValue }) => {
                return (
                  <Form.Item
                    rules={rules.certificate_status}
                    label="Certificate status *"
                    name="certificate_status"
                  >
                    <Select
                      // showSearch
                      onFocus={() => handleError({ target: { name: "name" } })}
                      name="certificate_status"
                      placeholder={"Select from below"}
                      suffixIcon={<DropArrow />}
                      type="dropdown"
                      className="form_control skill_multiselect"
                      // defaultValue={status[0]?.name}
                      onChange={(e) => setStatus_cert(e)}
                    >
                      {status?.map((option, index) => (
                        <option key={index} value={option?.name}>
                          {option.name}
                        </option>
                      ))}
                    </Select>
                  </Form.Item>
                );
              }}
            </Form.Item>

            {certificate?.[0]?.certificate_status === "Issued" ||
              (status_cert === "Issued" && (
                <Form.Item name="issued_date" label="Certificate issued date">
                  <DatePicker
                    style={{ width: "100%" }}
                    format={"MM/DD/YYYY"}
                    name="issued_date"
                  />
                </Form.Item>
              ))}
            <div class="form_group form_footer d_flex_center">
              <button type="reset" className="btn btn_gray">
                cancel
              </button>
              <FilledButton
                type="submit"
                loading={btnLoader}
                value={"update"}
                className="btn btn_primary"
              />
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default AddCertificatePop;
